import React from 'react';

/**
 * ProgressBar Component
 *
 * Displays a progress indicator for the multi-step form
 *
 * @param {Number} currentStep - Current step index
 * @param {Number} totalSteps - Total number of steps
 */
const ProgressBar = ({ currentStep, totalSteps }) => {
  return (
    <div className="progress-indicator mb-6">
      <div className="columns is-mobile is-gapless">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div key={index} className="column">
            <div
              className={`progress-step ${
                index <= currentStep ? 'is-active' : ''
              }`}
            >
              <div className="progress-indicator-bar"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
